import React from "react";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";

export const PdfDocumentPreview = React.forwardRef(({ url }, ref) => {
  return (
    <ElementRoot loaded>
      <span>
        <iframe
          id="pdf"
          ref={ref}
          src={url}
        />
      </span>
    </ElementRoot>
  );
});

PdfDocumentPreview.propTypes = mediaElementShape;

PdfDocumentPreview.displayName = "PdfDocumentPreview";
